import React, { Component } from 'react';
import Slider from "react-slick";
import { HomeTestimonial } from '../../../utils/script';

class Review extends Component {
    

    render() {
        
        return (

           <></>
       
        );
    }
}

export default Review;
